import { LoanStatisticsIndividual, LoanStatisticsOverview, LoanStatisticsShared } from '../../../store/api';
import { IssueUsageOption, IssueUsageStatistic, IssueUsageStatisticLoansLeft, LoansLeft } from '../types/IssueUsage';
import { shouldShowUsagePercentage } from '../utils/shouldShowUsagePercentage';

const isNullOrUndefined = <T>(value: T | null | undefined): value is null | undefined => {
    return value === null || value === undefined;
};

function mapLoansLeft(loansLeft?: number | null): IssueUsageStatisticLoansLeft {
    switch (loansLeft) {
        case undefined:
        case null:
            return { type: LoansLeft.LoansLeftUnlimited };
        case 0:
            return { type: LoansLeft.LoansLeftZero };
        default:
            return { type: LoansLeft.LoansLeftValue, loansLeft };
    }
}

export function mapIssueUsageIndividual(loanStatistics: LoanStatisticsIndividual): IssueUsageStatistic {
    const { loans, loansLeft, usagePercentage, reserves } = loanStatistics;
    return {
        type: IssueUsageOption.IssueUsageStatistic,
        loans: { ownLoans: loans },
        loansLeft: mapLoansLeft(loansLeft),
        reserves: reserves > 0 ? { ownReserves: reserves } : undefined,
        usagePercentage:
            !isNullOrUndefined<number>(usagePercentage) && shouldShowUsagePercentage(usagePercentage)
                ? usagePercentage
                : undefined
    };
}

export function mapIssueUsageOverviewAndShared(
    loanStatistics: LoanStatisticsOverview | LoanStatisticsShared,
    hasSharedSubscription: boolean
): IssueUsageStatistic {
    const { ownLoans, foreignLoans, loansLeft, usagePercentage, ownReserves, foreignReserves } = loanStatistics;
    return {
        type: IssueUsageOption.IssueUsageStatistic,
        loans: {
            ownLoans,
            foreignLoans: hasSharedSubscription ? (foreignLoans != null ? foreignLoans : 0) : undefined
        },
        loansLeft: mapLoansLeft(loansLeft),
        reserves:
            ownReserves > 0 || (foreignReserves !== null && foreignReserves > 0)
                ? {
                      ownReserves,
                      foreignReserves: hasSharedSubscription
                          ? foreignReserves !== null
                              ? foreignReserves
                              : 0
                          : undefined
                  }
                : undefined,
        usagePercentage:
            !isNullOrUndefined<number>(usagePercentage) && shouldShowUsagePercentage(usagePercentage)
                ? usagePercentage
                : undefined
    };
}
